module.exports = __webpack_public_path__ + "img/ss.e3933b44.svg";